import { useMemo } from 'react';
import { FilterTypeTrackingMap } from '../../shared/constants';
import { useQuickSearchModal } from '../../shared/contexts';

export const useQuickSearchAppliedFilterTypes = () => {
  const { scopedToProjectId } = useQuickSearchModal();

  const appliedFilterTypes = useMemo(() => {
    return scopedToProjectId
      ? [FilterTypeTrackingMap.LOCATION_FILTER]
      : [FilterTypeTrackingMap.NONE];
  }, [scopedToProjectId]);

  return appliedFilterTypes;
};
